module.exports = __webpack_public_path__ + "img/fi-rr-angle-small-right.36a285ea.svg";